export default __webpack_public_path__ + "static/media/i206jk.16fd135e.webp";